// value is copied from constants.ts because importing that here results in all
// values being undefined.
export const value = <T>(key: string, def: T): T => {
  if (window && window.__env && window.__env.hasOwnProperty(key)) {
    return window.__env[key] as T
  }
  return def
}

const ASSET_PATH = value('ASSET_PATH', '')

// eslint-disable-next-line no-var
declare var __webpack_public_path__: string

if (ASSET_PATH !== '') {
  __webpack_public_path__ = `${ASSET_PATH}/web/` // eslint-disable-line
}
